import React, { ComponentProps } from 'react';
import { styled } from '@mui/material';

import { SizingMultiplier } from '@ocx/ui';

export const BoxItemComponent: React.FC<ComponentProps<'div'>> = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(SizingMultiplier.sm),
  backgroundColor: theme.palette.background.box,
  padding: theme.spacing(SizingMultiplier.sm),
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flexGrow: 1,
  minWidth: 0,
}));
